export default function isEmailValid(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }
  // From http://stackoverflow.com/a/46181/5430854
  const pattern =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return pattern.test(email.trim());
}
